
        import Ext_0 from './app/render/integrations/pipeorders/pipeorders'
import Ext_1 from './app/render/integrations/gtm/gtm'
import Ext_2 from './app/render/integrations/klaviyo/klaviyo'
import Ext_3 from './app/render/integrations/cdp/cdp'
import Ext_4 from './app/render/integrations/fitnessfunctions/fitnessfunctions'
import Ext_5 from './app/render/integrations/trackingProperties/trackingProperties'
import Ext_6 from './app/render/integrations/segment/segment'
import Ext_7 from './app/render/integrations/bugsnag/bugsnag'
import Ext_8 from './app/render/integrations/primer/primer'
        export default [{
          type: 'PIPEORDERS',
          key: 'global.pipeorders',
          singleton: true,
          headClientOnly: false,
          config: {"apiHost":"https://api-pipeorders.in.nutrameg.com"},
          module: Ext_0
        },
{
          type: 'GTM',
          key: 'brand.gtm',
          singleton: true,
          headClientOnly: true,
          config: {"containerId":"GTM-P84R38T3","cookieConsentEnabled":true},
          module: Ext_1
        },
{
          type: 'KLAVIYO',
          key: 'brand.nutramegHqLimited',
          singleton: true,
          headClientOnly: true,
          config: {"publicKey":"V9SQNS"},
          module: Ext_2
        },
{
          type: 'CDP',
          key: 'brand.cdpFasting',
          singleton: true,
          headClientOnly: false,
          config: {"writeKey":"J4Fy8IM24_w9Oxkv1qf9nyGI9bNcd5gjv9bL7qeBKyQ","host":"https://events.cdp.in.nutrameg.com"},
          module: Ext_3
        },
{
          type: 'FITNESS_FUNCTIONS',
          key: 'global.fitnessFunctions',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_4
        },
{
          type: 'TRACKING_PROPERTIES',
          key: 'global.trackingProperties',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_5
        },
{
          type: 'SEGMENT',
          key: 'global.segmentGlobalWriteKey',
          singleton: true,
          headClientOnly: true,
          config: {"writeKey":"1xyxAgckLKpBgGGy1PN60gqEWoAjr8hQ"},
          module: Ext_6
        },
{
          type: 'BUGSNAG',
          key: 'global.bugsnag',
          singleton: true,
          headClientOnly: false,
          config: {"apiKey":"78b6ac6437fe8257e92c9ffc81995655","releaseStage":"production","appVersion":"0.0.1","enabledReleaseStages":"production"},
          module: Ext_7
        },
{
          type: 'PRIMER',
          key: 'PRIMER',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_8
        }]
      